module.exports = __webpack_public_path__ + "img/强浓雾.b59eddfc.png";